// Stimulus controller for adding and removing nested association fields dynamically.
//
// Usage:
//
// 1. Template:
//    - Create a template element with data-kegs--nested-association-form-target="template".
//    - Inside it, generate a blank set of fields using simple_fields_for with child_index: 'NEW_RECORD', e.g.:
//      <%= f.simple_fields_for :my_association, MyAssociationClass.new, child_index: 'NEW_RECORD' do |assoc| %>
//        ...
//      <% end %>
//
// 2. Add Record Button:
//    - Place a button or link with data-kegs--nested-association-form-target="addRecordButton".
//    - Attach data-action="kegs--nested-association-form#addRecord" to it.
//    - New records will be inserted directly *above* this button.
//
// 3. Remove Record Button:
//    - Wrap each nested record inside a container with class "nested-record".
//    - Add data-new-record to the wrapper, set to "true" for new records and "false" for persisted records.
//    - Inside each wrapper, add a button or link with data-action="kegs--nested-association-form#removeRecord".
//
// Behavior:
//
// - When adding:
//    - Duplicates the template, replacing all instances of "NEW_RECORD" with a timestamp for unique field names.
//
// - When removing:
//    - New (unsaved) records are removed from the DOM immediately.
//    - Existing (persisted) records are marked for destruction by setting the hidden `_destroy` field to `1` and hiding the fields.
//
// Notes:
// - Ensure `f.input :_destroy, as: :hidden` (or similar) is present in your nested fields partial for persisted records.
//

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["addRecordButton", "template"];

  addRecord(event) {
    event.preventDefault();
    
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.addRecordButtonTarget.insertAdjacentHTML('beforebegin', content);
    
    // Necessary for Material Design Lite to upgrade newly added elements
    componentHandler.upgradeAllRegistered();

    // Initialize any new datetime pickers
    flatpickr(".datetimepicker", {
      enableTime: true,
      altInput: true,
      altFormat: "F d, Y - h:iK",
      dateFormat: "Y-m-d H:i",
    });

    // Initialize all select2 elements
    const selectElements = document.querySelectorAll('select.select2');
    selectElements.forEach((select) => $(select).select2());
  }

  removeRecord(event) {
    event.preventDefault();
    
    const wrapper = event.target.closest('.nested-record');
    
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      const destroyField = wrapper.querySelector("input[name*='[_destroy]']");
      if (destroyField) {
        destroyField.value = 1;
      }
      wrapper.style.display = "none";
    }
  }
}
